import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Chip, Divider, Skeleton, Stack, Typography } from '@mui/material';
import Card from '../common/Card';

const MetricRow = ({ label, metric }) => (
  <Stack direction="row" justifyContent="space-between">
    <Typography variant="body2">{label}</Typography>
    <Typography variant="body2" color="text.secondary">
      Avg {metric?.avg ?? 'N/A'} / Median {metric?.median ?? 'N/A'}
    </Typography>
  </Stack>
);

const TradeQualityCard = ({ closedTrades, requiredClosedTrades, enrichment, metrics, warnings, loading = false }) => {
  return (
    <Card title="Trade Quality">
      {loading ? (
        <Stack spacing={1.5}>
          <Skeleton variant="rounded" height={30} />
          <Skeleton variant="rounded" height={24} />
          <Skeleton variant="rounded" height={24} />
        </Stack>
      ) : closedTrades === 0 ? (
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">Trade quality chưa có data.</Typography>
          <Alert severity="info">Chưa đủ closed trades để đánh giá chất lượng dữ liệu.</Alert>
        </Stack>
      ) : (
      <Stack spacing={1.5} divider={<Divider flexItem />}>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          <Chip label={`Closed trades: ${closedTrades}/${requiredClosedTrades}`} color={closedTrades >= requiredClosedTrades ? 'success' : 'warning'} />
          <Chip label={`Complete: ${enrichment?.complete || 0}`} color="success" />
          <Chip label={`Partial: ${enrichment?.partial || 0}`} color="warning" />
          <Chip label={`Failed: ${enrichment?.failed || 0}`} color="error" />
        </Stack>

        <Typography variant="body2" color="text.secondary">
          Enrichment complete ratio: {enrichment?.completeRatio ?? 0}
        </Typography>

        <Stack spacing={1}>
          <MetricRow label="MFE" metric={metrics?.mfe} />
          <MetricRow label="MAE" metric={metrics?.mae} />
          <MetricRow label="RR Realized" metric={metrics?.rr_realized} />
        </Stack>

        <Stack spacing={1}>
          {(warnings || []).length ? warnings.map((warning) => (
            <Alert key={warning.code} severity="warning">{warning.message}</Alert>
          )) : (
            <Typography variant="body2" color="text.secondary">No active warnings.</Typography>
          )}
        </Stack>
      </Stack>
      )}
    </Card>
  );
};

TradeQualityCard.propTypes = {
  closedTrades: PropTypes.number,
  requiredClosedTrades: PropTypes.number,
  enrichment: PropTypes.object,
  metrics: PropTypes.object,
  warnings: PropTypes.array,
  loading: PropTypes.bool,
};

export default TradeQualityCard;
